const api = {
	// 客服
	chatpage:'chat/page?sort=addtime&order=desc',
	chatbyuseridpage: 'chat/page?sort=addtime&order=asc&userid=',
	chatsave: 'chat/save',
	// 论坛
	forumpage: 'forum/page?parentid=0&sort=addtime&order=desc',
	forumdelete : 'forum/delete',
	forumsave: 'forum/save',
	foruminfo: 'forum/info/',
	forumupdate: 'forum/update',
	// 积分预约
	orderpage: 'orders/page',
	orderdelete: 'orders/delete',
	orderinfo: 'orders/info/',
	ordersave: 'orders/save',
	orderupdate: 'orders/update',
	// 配置
	configpage: 'config/page',
	configdelete: 'config/delete',
	configinfo: 'config/info/',
	configsave: 'config/save',
	configupdate: 'config/update'

}

export default api
